var _path, _path2, _path3, _path4, _path5, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsights6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8224 4.65883C33.0341 2.83844 36.9659 2.83844 40.1776 4.65883L49.4749 9.92858L58.6874 15.3455C61.8698 17.2167 63.8357 20.6217 63.865 24.3133L63.9499 35L63.865 45.6867C63.8357 49.3783 61.8698 52.7833 58.6874 54.6545L49.475 60.0714L40.1776 65.3412C36.9659 67.1616 33.0341 67.1616 29.8224 65.3412L20.5249 60.0713L11.3125 54.6545C8.13021 52.7833 6.16434 49.3783 6.135 45.6867L6.05005 35L6.135 24.3133C6.16434 20.6217 8.13021 17.2167 11.3126 15.3455L20.525 9.92861L29.8224 4.65883Z",
    fill: "#17233B",
    stroke: "#EDFF6B",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 40C32 42.2091 30.2091 44 28 44C25.7909 44 24 42.2091 24 40C24 37.7909 25.7909 36 28 36C30.2091 36 32 37.7909 32 40Z",
    stroke: "white",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46 40C46 42.2091 44.2091 44 42 44C39.7909 44 38 42.2091 38 40C38 37.7909 39.7909 36 42 36C44.2091 36 46 37.7909 46 40Z",
    stroke: "white",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31 33C31 32.7268 31.1095 32.4793 31.287 32.2988L34.3299 29.2578C34.5072 29.0976 34.7422 29 35 29C35.2811 29 35.5351 29.116 35.7167 29.3026C35.7683 29.3556 35.814 29.4142 35.8528 29.4775C35.9462 29.6296 36 29.8085 36 30C36 30.2712 35.892 30.5172 35.7167 30.6974L32.6794 33.7338L35 36V36.5L31.287 33.7012C31.1095 33.5207 31 33.2732 31 33Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35 36.5L31.287 33.7012C31.1095 33.5207 31 33.2732 31 33C31 32.7268 31.1095 32.4793 31.287 32.2988L34.3299 29.2578C34.5072 29.0976 34.7422 29 35 29C35.2811 29 35.5351 29.116 35.7167 29.3026M35 36.5V42M35 36.5V36L32.6794 33.7338L35.7167 30.6974C35.892 30.5172 36 30.2712 36 30C36 29.7288 35.892 29.4828 35.7167 29.3026M35.7167 29.3026C36.6445 30.5351 39.2 33 42 33",
    stroke: "white",
    strokeWidth: 1.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.3725,
    cy: 26.5766,
    r: 1.49995,
    fill: "white",
    stroke: "white",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsights6);
export default __webpack_public_path__ + "static/media/insights6.05bc928accc20f2f8d5c3645f7bcc681.svg";
export { ForwardRef as ReactComponent };